import * as constants from './constants';
import {
  fromJS
} from 'immutable';
const defaultState =  fromJS({
    subjectInfo: [],
    resource:{},
    questionList:[],
    addQuestion:[],
    userQuestionList:[],
    otherQuestionList:[],
    userinfo:JSON.parse(localStorage.getItem("userinfo")||"{}"),
    finishedList: [],
    finishedListLock: [],
    finishedPeriod: [],
    pop: false
})

export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.CHANGE_SUBJECT_INFO:
            return state.merge({
               subjectInfo:action.subjectInfo,
               resource:action.resource
            });
        case constants.CHANGE_QUESTION_LIST:
            return state.merge({
               questionList:action.questionList
            });
        case constants.CHANGE_USER_QUESTION_LIST:
            return state.merge({
               userQuestionList:action.userQuestionList
            });
        case constants.CHANGE_OTHER_QUESTION_LIST:
            return state.merge({
               otherQuestionList:action.otherQuestionList
            });
        case constants.CHANGE_FINISHEDLIST:
            return state.merge({
                finishedList: action.finishedList
            })
        case constants.CHANGE_FINISHEDLIST_LOCK:
            return state.merge({
                finishedListLock: action.finishedListLock
            })
        case constants.CHANGE_PLAY_TIME:
            return state.merge({
                finishedPeriod: action.finishedPeriod
            })
        case constants.CHANGE_POP:
            return state.merge({
                pop: action.pop
            })
        default:
            return state;
    }
}
